module.exports = __webpack_public_path__ + "static/media/long_arrow.3bc59621.svg";